import React from "react";
import classes from "./Logo.module.scss"

const Logo = ({logoDimesnion }) => {
    const {width,height,logoImage,altText} = logoDimesnion;
    return (
        <img src={logoImage} width={width} height={height}  alt={altText} className={classes.logoImage} />
    )
}

export default Logo